import { webchatClasses } from '../../styles/classes'
import { Avatar } from '../Avatar'

type Props = {
  botAvatar?: string
  botDescription?: string
  botName?: string
}

export function Marquee({ botAvatar, botDescription, botName }: Props) {
  const {
    messageList: { marquee },
  } = webchatClasses

  return (
    <li {...marquee.container}>
      <Avatar src={botAvatar} {...marquee.avatar}>
        {(botName || 'Bot').slice(0, 1)}
      </Avatar>
      <div {...marquee.content}>
        <h1 {...marquee.title}>{botName || 'Bot'}</h1>
        <p {...marquee.description}>{botDescription}</p>
      </div>
    </li>
  )
}
